import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'cookies';
import { GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';
import ShaqvanaContainer from '~/components/shaqvana/ShaqvanaContainer';
import { appAssetsCdnUrl } from '~/constants/environment';
import { shaqvanaProject, shaqvanaTrack } from '~/constants/eventable';
import ShaqvanaProviders, {
  type ShaqvanaProvidersProps
} from '~/context/shaqvana/ShaqvanaProviders';
import { ShaqvanaStaticConfigs } from '~/server-props/shaqvana/constants';
import getProps from '~/server-props/shaqvana/getProps';
import getRequestContext from '~/server-props/shaqvana/getRequestContext';
import { ErrorBoundary } from '~/utilities/ErrorBoundary';

function PageContainer() {
  useEffectOnce(() => {
    datadogRum.addAction('Rendered Shaqvana');
  }, []);

  return <ShaqvanaContainer />;
}

type OwnProps = {
  forProviders: ShaqvanaProvidersProps;
};

export default function Shaqvana(props: OwnProps) {
  return (
    <div>
      <NextSeo
        title="Shaq Will Drive You Happy | Carvana"
        description="Shaquille O’Neal and Carvana team up to bring you Shaqvana. Chat with the world's first Shaq-powered AI, shop with Shaq for your next vehicle, and buy your next ride online with ease and confidence."
        openGraph={{
          images: [
            {
              url: `${appAssetsCdnUrl}/images/shaqvana/shaq-open-graph.png`,
              alt: 'Shaqvana',
              height: 645,
              width: 1200
            }
          ]
        }}
      />
      <ErrorBoundary section="Shaqvana Page">
        <ShaqvanaProviders
          eventableProject={shaqvanaProject}
          eventableTrack={shaqvanaTrack}
          {...props.forProviders}
        >
          <PageContainer />
        </ShaqvanaProviders>
      </ErrorBoundary>
    </div>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const requestContext = await getRequestContext(context.req);
  const serverCookies = new Cookies(context.req, context.res, { secure: true });

  return getProps(
    context,
    requestContext,
    serverCookies,
    ShaqvanaStaticConfigs
  );
}
